import React from "react";
import { Box, Tooltip } from "@material-ui/core";
import TargetColor from "../../../TargetColor/TargetColor";
import { useStyles } from "../styles";
import DefaultTargetImg from "../../../../assets/images/target-default-image.svg";
import { get } from "lodash";

const TagetImageTypeTitle = ({ colProps, targetTypeInfo }) => {
  const classes = useStyles();
  const { target } = colProps.dataItem;
  return (
    <td>
      <Box className={classes.targetName} display="flex" alignItems="center">
        <Box>
          <img
            src={
              get(target, "logo.fileName", "")
                ? `${process.env.REACT_APP_CLOUD_FRONT_URL}/${get(
                    target,
                    "logo.fileName",
                    ""
                  )}`
                : get(target, "logo.key", "")
                ? `${process.env.REACT_APP_CLOUD_FRONT_URL}/${get(
                    target,
                    "logo.key",
                    ""
                  )}`
                : DefaultTargetImg
            }
            alt="checkinimage"
            className={`${classes.targetImage} target-img`}
          />
        </Box>
        <Box width="70%">
          <Tooltip
            placement="bottom-start"
            title={colProps.dataItem.targetTitle}
          >
            <span className={`${classes.targetTitle} truncate-txt d-block`}>
              {colProps.dataItem.targetTitle}
            </span>
          </Tooltip>
          {targetTypeInfo ? (
            <TargetColor targetType={get(target, "type", "")} showName={true} />
          ) : (
            ""
          )}
        </Box>
      </Box>
    </td>
  );
};

export default TagetImageTypeTitle;
